//Urls Base
const UrlBase = {
  base_url: window.REACT_APP_BASE_URL
}

export default {
  //Url's de inicio y cierre de sesión
  base_url: `${UrlBase.base_url}`
} 